import { all, call, takeEvery, fork } from "redux-saga/effects";
import requestFunction from "../Utils/SagaGenericFunction";
import newRequestFunction from "../Utils/newSGF";

import {
  // POST_APPROVAL_COMMENT,
  ADD_TRAINER,
  ACTIVATE_TRAINER,
  DEACTIVATE_TRAINER,
  FETCH_ALL_TRAINERS,
  FETCH_TRAINER_BY_ID,
  UPDATE_TRAINER,
  FETCH_ALL_TOTAL_TRAINERS_DETAILS,
  EXPORT_TRAINERS,
  PRINT_TRAINERS,
  FETCH_TRAINER_SELECT,
  DOWNLOAD_TRAINER_BULK_TEMPLATE,
  ADD_BULK_TRAINER,

  // virtual approval
  VIRTUALLY_APPROVE_TRAINER,
  FETCH_TRAINING_CENTER_FILE_BY_ID,

  // training center report
  FETCH_TRAINING_CENTER_REPORT,
  EXPORT_TRAINING_CENTER_REPORT,
  PRINT_TRAINING_CENTER_REPORT,
  FETCH_TRAINER_BY_EMAIL,
  UPDATE_TRAINING_CENTER,

  EXPORT_VIRTUALLY_APPROVED_TRAINERS,
} from "../ActionTypes";

import {
  // approvalSuccess,
  addNewTrainerSuccess,
  activateTrainerSuccess,
  deactivateTrainerSuccess,
  fetchTrainersSuccess,
  fetchTrainerByIdSuccess,
  updateTrainerSuccess,
  fetchAllTotalTrainersDetailsSuccess,
  exportTrainersSuccess,
  printTrainersPdfSuccess,
  fetchTrainerSelectSuccess,
  downloadBulkTrainerSuccess,
  addBulkTrainerSuccess,

  // virtual approval
  virtuallyApproveTrainerSuccess,
  virtuallyApproveTrainerFailure,

  fetchTrainingCenterFileByIdSuccess,
  fetchTrainingCenterFileByIdFailure,
  
  // training center report
  fetchTrainingCenterReportSuccess,
  fetchTrainingCenterReportFailure,

  exportTrainingCenterReportSuccess,
  exportTrainingCenterReportFailure,

  printTrainingCenterReportFailure,
  printTrainingCenterReportSuccess,
  fetchTrainerByEmailSuccess,
  fetchTrainerByEmailFailure,
  updateTrainingCenterSuccess,
  updateTrainingCenterFailure,

  exportVirtuallyApprovedTrainersSuccess,
  exportVirtuallyApprovedTrainersFailure,
} from "../Actions";

import { 
  createTrainers, 
  getAllTrainers, 
  activateTrainers, 
  deactivateTrainers, 
  getTrainerById, 
  updateTrainer, 
  getAllTotalTrainersDetails, 
  exportTrainers, 
  printTrainers, 
  getAllTrainerSelect, 
  downloadTrainerBulkTemplateApi, 
  createBulkTrainersApi,
  
  // virtual approval
  postApprovalComment, 
  getTrainingCenterFileByIdApi,

  // training center report
  getTrainingCenterReport,
  exportTrainingCenterReport,
  getTrainersReportDataNoPagination,
  getTrainerByEmailApi,
  updateTrainingCenterApi,

  exportVirtuallyApprovedTrainersApi,
} from "../Api";

// =================Create New Trainers sagas================

const createTrainersRequest = function* ({ payload }) {
  yield call(requestFunction, addNewTrainerSuccess, createTrainers, payload);
};

export const createTrainer = function* () {
  yield takeEvery(ADD_TRAINER, createTrainersRequest);
};


// Virtual Approval
const postApprovalCommentWatcher = function* ({ payload }) {
  yield call(newRequestFunction, virtuallyApproveTrainerSuccess, virtuallyApproveTrainerFailure, postApprovalComment, payload)
}

export const postApprovalCommentRequest = function* () {
  yield takeEvery(VIRTUALLY_APPROVE_TRAINER, postApprovalCommentWatcher)
}


const exportVirtuallyApprovedTrainersWatcher = function* ({ payload }) {
  yield call(newRequestFunction, exportVirtuallyApprovedTrainersSuccess, exportVirtuallyApprovedTrainersFailure, exportVirtuallyApprovedTrainersApi, payload)
}

export const exportVirtuallyApprovedTrainersRequest = function* () {
  yield takeEvery(EXPORT_VIRTUALLY_APPROVED_TRAINERS, exportVirtuallyApprovedTrainersWatcher)
}


const fetchTrainingCenterFileByIdWatcher = function* ({ payload }) {
  yield call(newRequestFunction, fetchTrainingCenterFileByIdSuccess, fetchTrainingCenterFileByIdFailure, getTrainingCenterFileByIdApi, payload)
}

export const getTrainingCenterFileByIdRequest = function* () {
  yield takeEvery(FETCH_TRAINING_CENTER_FILE_BY_ID, fetchTrainingCenterFileByIdWatcher)
}


// =================training center report================
const getTrainingCenterReportWatcher = function* ({ payload }) {
  yield call(newRequestFunction, fetchTrainingCenterReportSuccess, fetchTrainingCenterReportFailure, getTrainingCenterReport, payload )
}

export const getTrainingCenterReportRequest = function* () {
  yield takeEvery(FETCH_TRAINING_CENTER_REPORT, getTrainingCenterReportWatcher)
}

// export training center
const exportTrainingCenterReportWatcher = function* ({ payload }) {
  yield call(newRequestFunction, exportTrainingCenterReportSuccess, exportTrainingCenterReportFailure, exportTrainingCenterReport, payload)
}

export const exportTrainingCenterReportRequest = function* () {
  yield takeEvery(EXPORT_TRAINING_CENTER_REPORT, exportTrainingCenterReportWatcher)
}

// print trainers report
const printTrainersReportWatcher = function* ({ payload }) {
  yield call(newRequestFunction, printTrainingCenterReportSuccess, printTrainingCenterReportFailure, getTrainersReportDataNoPagination, payload)
}

export const printTrainersReportRequest = function* () {
  yield takeEvery(PRINT_TRAINING_CENTER_REPORT, printTrainersReportWatcher)
}


// =================fetch all Trainers sagas================

const fetchAllTrainersRequest = function* ({ payload }) {
  yield call(requestFunction, fetchTrainersSuccess, getAllTrainers, payload);
};

export const fetchAllTrainers = function* () {
  yield takeEvery(FETCH_ALL_TRAINERS, fetchAllTrainersRequest);
};


// =================Activate Trainers sagas================

const activateTrainerRequest = function* ({ payload }) {
  yield call(requestFunction, activateTrainerSuccess, activateTrainers, payload);
};

export const activateTrainer = function* () {
  yield takeEvery(ACTIVATE_TRAINER, activateTrainerRequest);
};


// =================Deactivate Trainers sagas================

const deactivateTrainerRequest = function* ({ payload }) {
  yield call(requestFunction, deactivateTrainerSuccess, deactivateTrainers, payload);
};

export const deactivateTrainer = function* () {
  yield takeEvery(DEACTIVATE_TRAINER, deactivateTrainerRequest);
};

// =================Fetch Trainer by Id sagas================

const fetchTrainerByIdRequest = function* ({ payload }) {
  yield call(requestFunction, fetchTrainerByIdSuccess, getTrainerById, payload);
};

export const fetchTrainerById = function* () {
  yield takeEvery(FETCH_TRAINER_BY_ID, fetchTrainerByIdRequest);
};

// // =================approve Trainer ================

// const postApprovalCommentRequest = function* ({ payload }) {
//   yield call(requestFunction, approvalSuccess, postApprovalComment, payload);
// };

// export const postApproval = function* () {
//   yield takeEvery(POST_APPROVAL_COMMENT, postApprovalCommentRequest);
// };

// =================Update Trainer sagas================
const updateTrainerRequest = function* ({ payload }) {
  yield call(requestFunction, updateTrainerSuccess, updateTrainer, payload);
};

export const updateTheTrainer = function* () {
  yield takeEvery(UPDATE_TRAINER, updateTrainerRequest);
};

// =================FETCH ALL Trainers Total sagas================
const fetchAllTrainersTotalDetailsRequest = function* ({ payload }) {
  yield call(requestFunction, fetchAllTotalTrainersDetailsSuccess, getAllTotalTrainersDetails, payload);
};

export const fetchAllTotalTrainersDetails = function* () {
  yield takeEvery(FETCH_ALL_TOTAL_TRAINERS_DETAILS, fetchAllTrainersTotalDetailsRequest);
};

// =================Export Trainers sagas================
const exportTrainersRequest = function* ({ payload }) {
  yield call(requestFunction, exportTrainersSuccess, exportTrainers, payload);
};

export const exportTheTrainers = function* () {
  yield takeEvery(EXPORT_TRAINERS, exportTrainersRequest);
};

// =================Print Trainers sagas================
const printTrainersRequest = function* ({ payload }) {
  yield call(requestFunction, printTrainersPdfSuccess, printTrainers, payload);
};

export const printTheTrainers = function* () {
  yield takeEvery(PRINT_TRAINERS, printTrainersRequest);
};

// =================FETCH Trainer Select sagas================
const fetchTrainerSelectRequest = function* ({ payload }) {
  yield call(requestFunction, fetchTrainerSelectSuccess, getAllTrainerSelect, payload);
};

export const fetchTheTrainerSelect = function* () {
  yield takeEvery(FETCH_TRAINER_SELECT, fetchTrainerSelectRequest);
};

// =================Download Bulk Trainers Template sagas================
const downloadBulkTrainerRequest = function* ({ payload }) {
  yield call(requestFunction, downloadBulkTrainerSuccess, downloadTrainerBulkTemplateApi, payload);
};

export const downloadTheBulkTrainers = function* () {
  yield takeEvery(DOWNLOAD_TRAINER_BULK_TEMPLATE, downloadBulkTrainerRequest);
};

// =================Add Bulk Trainers sagas================

const createBulkTrainerRequest = function* ({ payload }) {
  yield call(requestFunction, addBulkTrainerSuccess, createBulkTrainersApi, payload);
};

export const createTheBulkTrainers = function* () {
  yield takeEvery(ADD_BULK_TRAINER, createBulkTrainerRequest);
};

// Get Trainer By Email Saga
const getTrainerByEmailRequest = function* ({ payload }) {
  yield call(
    newRequestFunction,
    fetchTrainerByEmailSuccess,
    fetchTrainerByEmailFailure,
    getTrainerByEmailApi,
    payload
  );
};

const getTrainerByEmailWatcher = function* () {
  yield takeEvery(FETCH_TRAINER_BY_EMAIL, getTrainerByEmailRequest);
};

// =================Update Training Center sagas================

const updateTrainingCenterRequest = function* ({ payload }) {
  yield call(newRequestFunction, updateTrainingCenterSuccess, updateTrainingCenterFailure, updateTrainingCenterApi, payload);
};

export const updateTrainingCenterWatcher = function* () {
  yield takeEvery(UPDATE_TRAINING_CENTER, updateTrainingCenterRequest);
};

export default function* rootSaga() {
  yield all([
    fork(createTrainer), 
    fork(fetchAllTrainers), 
    fork(activateTrainer), 
    fork(deactivateTrainer), 
    fork(fetchTrainerById), 
    fork(updateTheTrainer), 
    fork(fetchAllTotalTrainersDetails), 
    fork(exportTheTrainers), 
    fork(printTheTrainers), 
    fork(fetchTheTrainerSelect), 
    fork(downloadTheBulkTrainers), 
    fork(createTheBulkTrainers), 
    // fork(postApproval),
    
    // virtual approval
    fork(postApprovalCommentRequest),
    fork(getTrainingCenterFileByIdRequest),

    // trainers report page
    fork(getTrainingCenterReportRequest),
    fork(exportTrainingCenterReportRequest),
    fork(printTrainersReportRequest),

    fork(getTrainerByEmailWatcher),
    fork(updateTrainingCenterWatcher),
  
    fork(exportVirtuallyApprovedTrainersRequest),
  ]);


}

